import React, { FC, Fragment, useEffect, useState, useCallback, useRef } from 'react';
import { Card, Form as AntForm, Button, Select, Table, message } from 'antd';
import { FormComponentProps } from 'antd/es/form';
import { Entity } from '@comall-backend-builder/core/lib/parser';
import { services } from '@comall-backend-builder/core';
import SelectSkn from './components/selectSkn';
import lodash from 'lodash';
import { errorHandle } from '../../services';
import './index.less';

const api = services.api;
const { Option } = Select;
const { debounce } = lodash;

export interface CategoryFilterAttrTableProps {
    entity: Entity;
    params: any;
    componentId: string;
    form: FormComponentProps['form'];
}
export const SknsubstitutionAddDom: FC = (props: any) => {
    const params = props.params || {};
    const id = params.id || '';
    const [loading, setLoading] = useState(false);
    const [selectId, setSelectId] = useState('');
    const [tableData, setTableData] = useState([]);
    const [visible, setVisible] = useState(false);
    const [selectOrderId, setSelectOrderId] = useState<any>(undefined);
    const [dicList, setDicList] = useState([]);
    const [showErr, setShowErr] = useState(false);
    const goBack = () => {
        services.navigation.goto('/trade/changeSKu');
    };

    const handelSave = debounce(() => {
        const orderItems = tableData ? tableData.filter((item) => item.newSku) : [];
        const newSkuList = orderItems.map((item) => {
            const json = {
                ...item,
                oldSku: item.newSkuTag || item.oldSku,
                oldSkn: item.newSknTag || item.oldSkn,
            };
            delete json.newSkuTag;
            delete json.newSknTag;
            return json;
        });
        if (!orderItems.length) {
            message.warning('请选择置换商品！');
            return;
        }
        const params = {
            orderNumber: selectOrderId,
            orderItems: newSkuList,
        };
        setLoading(true);
        api.post({ ...params }, { apiPath: `/orderReplaceSkn/replaceSkuSubmitNew` })
            .then((res: any) => {
                if (res.resultCode != 200 && res?.resultCode != 0) {
                    message.error(res.resultMsg);
                } else {
                    message.success('提交成功！');
                    setTimeout(() => {
                        goBack();
                    }, 200);
                }
            })
            .catch(errorHandle)
            .finally(() => {
                setLoading(false);
            });
    }, 500);

    const columns: any[] = [
        {
            title: '华夏款号',
            dataIndex: 'styleCode',
            width: 130,
            align: 'center',
        },
        {
            title: '原订单SKU',
            dataIndex: 'oldSku',
            width: 160,
            align: 'center',
        },
        {
            title: '原订单SKN',
            dataIndex: 'oldSkn',
            width: 160,
            align: 'center',
        },
        {
            title: '原订单商品名称',
            dataIndex: 'oldSkuName',
            width: 160,
            align: 'center',
        },
        {
            title: '原订单商品售价',
            dataIndex: 'oldSkuPrice',
            width: 100,
            align: 'center',
        },
        {
            title: '原商品库存位置',
            dataIndex: 'skuWarehouseName',
            width: 200,
            render: (_: any, record: any) => {
                return record.oldSkuWarehouseCode && record.oldSkuWarehouseName
                    ? `${record.oldSkuWarehouseCode}-${record.oldSkuWarehouseName}`
                    : '';
            },
            align: 'center',
        },
        {
            title: '置换后sku',
            dataIndex: 'newSku',
            width: 160,
            align: 'center',
        },
        {
            title: '置换后SKN',
            dataIndex: 'newSkn',
            width: 160,
            align: 'center',
        },
        {
            title: '置换后商品名称',
            dataIndex: 'newSkuName',
            width: 160,
            align: 'center',
        },
        {
            title: '置换后商品售价',
            dataIndex: 'newSkuPrice',
            width: 100,
            align: 'center',
        },
        {
            title: '置换后库存位置',
            dataIndex: 'newSkuWarehouseName',
            width: 200,
            render: (_: any, record: any) => {
                return record.newSkuWarehouseName && record.newSkuWarehouseCode
                    ? `${record.newSkuWarehouseCode}-${record.newSkuWarehouseName}`
                    : '';
            },
            align: 'center',
        },
        {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 120,
            align: 'center',
            render: (_: any, record: any) => (
                <>
                    {record.newType === 'PRODUCT_NEW' && !record.alreadyChange ? (
                        <a
                            style={{ display: 'inline-block', marginLeft: '12px' }}
                            type="link"
                            onClick={() => {
                                setSelectId(record.newSkuTag || record.oldSku);
                                setVisible(true);
                            }}
                        >
                            置换商品
                        </a>
                    ) : null}
                </>
            ),
        },
    ];

    const handleSelectSkn = (data?: any) => {
        if (!!data && data.length) {
            const selectItem = data[0];
            const newTableData = tableData.map((item: any) => {
                if (item.newSkuTag === selectId) {
                    return {
                        ...item,
                        newSku: selectItem.sku,
                        newSkn: selectItem.skn,
                        newSkuName: selectItem.showName,
                        newSkuWarehouseName: selectItem.sourceShopName,
                        newSkuWarehouseCode: selectItem.sourceShopCode,
                        newSkuPrice: selectItem.price,
                    };
                } else if (item.oldSku === selectId) {
                    return {
                        ...item,
                        newSku: selectItem.sku,
                        newSkn: selectItem.skn,
                        newSkuName: selectItem.showName,
                        newSkuWarehouseName: selectItem.sourceShopName,
                        newSkuWarehouseCode: selectItem.sourceShopCode,
                        newSkuPrice: selectItem.price,
                    };
                }
                return item;
            });
            setTableData(newTableData);
        }
        setVisible(false);
    };

    const handleGetselectOrderList = () => {
        setLoading(true);
        api.get(
            { orderStatus: '2' },
            { apiPath: `/orderReplaceSkn/get_order_item/${selectOrderId}` }
        )
            .then((res: any) => {
                const newTableData = res.map((item: any) => {
                    item.newSknTag = item.newSkn;
                    item.newSkuTag = item.newSku;
                    return item;
                });
                console.log(newTableData, '===res===');
                setTableData(newTableData);
            })
            .catch((err) => {
                const errorStr = err.toString();
                if (errorStr.indexOf('此状态不支持再次发起置换') > -1) {
                    setShowErr(true);
                } else {
                    message.error('系统错误！');
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleGetDic = () => {
        api.get(
            {},
            {
                apiPath: `/orderReplaceSkn/get_deliverable_order_list`,
            }
        )
            .then((res: any) => {
                setDicList(res);
            })
            .catch(errorHandle);
    };

    useEffect(() => {
        setShowErr(false);
        if (selectOrderId) {
            setTableData([]);
            handleGetselectOrderList();
        } else {
            setTableData([]);
        }
    }, [selectOrderId]);

    useEffect(() => {
        handleGetDic();
        if (id) {
            setSelectOrderId(id);
        }
    }, []);

    return (
        <Fragment>
            <div className="sunbathing-edit-dom">
                <Card title="新增">
                    <div className="title-tip">
                        <div style={{ fontWeight: 600 }}>规则</div>
                        <div>
                            ①有华夏款号的商品：只能置换相同【华夏款号】的商品。 ②
                            无华夏款号的商品：只能置换相同【货品品类】、【货品大类】、【货品大货形】、【货品小货形】的商品。
                            ③仅可选择与原商品价格相同的SKN（如价格不一致，可申请商品改价流程后再置换）
                        </div>
                        <div>
                            ④只能置换有库存的商品（不含锁定、在途库存）⑤只能置成品（不含包装、赠品）
                        </div>
                    </div>
                    <div className="sort-content">
                        <div className="label">选择销售订单: </div>
                        <div className="value">
                            <Select
                                placeholder="请选择"
                                onChange={(val) => {
                                    setSelectOrderId(val);
                                }}
                                allowClear
                                value={selectOrderId}
                                showSearch
                                style={{ width: 250 }}
                            >
                                {dicList.map((d) => (
                                    <Option key={d}>{d}</Option>
                                ))}
                            </Select>
                        </div>
                        <div className="err-value">
                            {showErr
                                ? '错误：该销售订单已发起过置换，状态为【置换中】，此状态不支持再次发起置换'
                                : null}
                        </div>
                    </div>

                    <div style={{ marginBottom: 12, marginLeft: 2, fontWeight: 600 }}>
                        原订单商品
                    </div>

                    <Table
                        scroll={{ x: 1900 }}
                        rowKey="id"
                        loading={loading}
                        columns={columns}
                        dataSource={tableData}
                        pagination={false}
                    />
                    <div className="footer-btn">
                        <Button type="primary" style={{ marginRight: '16px' }} onClick={handelSave}>
                            提交
                        </Button>
                        <Button
                            onClick={() => {
                                sessionStorage.setItem('fromSknSubstitution', 'true');
                                goBack();
                            }}
                        >
                            返回
                        </Button>
                    </div>
                </Card>
            </div>
            {visible && (
                <SelectSkn
                    selectId={selectId}
                    visible={visible}
                    handleSelectSkn={handleSelectSkn}
                />
            )}
        </Fragment>
    );
};

export const SknsubstitutionAdd = AntForm.create<CategoryFilterAttrTableProps>()(
    SknsubstitutionAddDom
);
